var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgColorSwirl(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.9993 6.00234C9.99979 4.0021 12 4.0021 12 6.00234C12 4.949 11.7228 3.91421 11.1961 3.00198C10.6694 2.08975 9.91189 1.33223 8.99966 0.805558C7.2674 -0.194564 6.26728 1.5377 5.9993 6.00234Z",
    fill: "#57BA48"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.9993 6.0014C9.7318 8.46581 10.7319 10.1981 8.99966 11.1982C9.91189 10.6715 10.6694 9.914 11.1961 9.00177C11.7228 8.08954 12 7.05475 12 6.0014C12 4.00116 9.99979 4.00116 5.9993 6.0014Z",
    fill: "#FFCB55"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00003 5.99927C5.73205 10.4639 4.73193 12.1962 2.99966 11.1961C3.91189 11.7227 4.94668 12 6.00003 12C7.05338 12 8.08817 11.7227 9.0004 11.1961C10.7327 10.1959 9.73254 8.46367 6.00003 5.99927Z",
    fill: "#FD9E47"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00076 5.99927C2.00027 7.99951 3.05176e-05 7.99951 3.05176e-05 5.99927C3.05176e-05 7.05262 0.277302 8.08741 0.803976 8.99963C1.33065 9.91186 2.08817 10.6694 3.0004 11.1961C4.73266 12.1962 5.73278 10.4639 6.00076 5.99927Z",
    fill: "#F85251"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00076 6.00245C2.26826 3.53805 1.26813 1.80579 3.0004 0.805664C2.08817 1.33234 1.33065 2.08986 0.803976 3.00208C0.277302 3.91431 3.05176e-05 4.9491 3.05176e-05 6.00245C3.05176e-05 8.00269 2.00027 8.00269 6.00076 6.00245Z",
    fill: "#8F96DE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99962 6.00073C6.26761 1.53609 7.26773 -0.196176 8.99999 0.803946C8.08776 0.277271 7.05297 0 5.99962 0C4.94627 0 3.91148 0.277271 2.99926 0.803946C1.26699 1.80407 2.26712 3.53633 5.99962 6.00073Z",
    fill: "#12A0EB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorSwirl);
export default __webpack_public_path__ + "static/media/color-swirl.4ae3a3583ca01d5e6183bc539186e9cd.svg";
export { ForwardRef as ReactComponent };